module.exports = __webpack_public_path__ + "images/d998e1ac14ba79aac1d2d5339bdb957a7171ebb7a78aa186e7f74f37e9335129.svg";